
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("ayHRb", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $aa644ce6040323ae$export$85dc19e234b280ee = ()=>{
    // Moving from <Icon> to <svg> since this icon will be replaced soon
    // and because of the complexity of scaling each path in the SVG.
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "34",
        height: "32",
        viewBox: "0 0 34 32",
        fill: "none",
        // TODO: Update the attribute below so it is translated.
        // eslint-disable-next-line no-restricted-syntax
        "aria-label": "Carousel",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "0.599609",
                y: "24.7302",
                width: "10",
                height: "6.30769",
                rx: "3.15385",
                fill: "#0055CC"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "11.5996",
                y: "24.7302",
                width: "10",
                height: "6.30769",
                rx: "3.15385",
                fill: "#454F59"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "22.5996",
                y: "24.7302",
                width: "10",
                height: "6.30769",
                rx: "3.15385",
                fill: "#454F59"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "1.23038",
                y: "1.18155",
                width: "31.5385",
                height: "20.6051",
                rx: "3.15385",
                stroke: "var(--ds-border, #0B120E24)",
                strokeOpacity: "0.84",
                strokeWidth: "1.26154"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M3.8125 19.7685L11.4577 11.5442L19.1029 19.7685H3.8125Z",
                fill: "#CCE0FF"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M7.89746 19.7688L19.1013 7.71631L30.305 19.7688H7.89746Z",
                fill: "#579DFF"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M7.43255 10.1951C8.94213 10.1951 10.1659 8.95398 10.1659 7.42298C10.1659 5.89199 8.94213 4.65088 7.43255 4.65088C5.92297 4.65088 4.69922 5.89199 4.69922 7.42298C4.69922 8.95398 5.92297 10.1951 7.43255 10.1951Z",
                fill: "#C25100"
            })
        ]
    });
};
module.exports["CarouselExtensionIcon"] = $aa644ce6040323ae$export$85dc19e234b280ee;

});


//# sourceMappingURL=carousel-extension-icon.c7fa125a.js.map
